import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/ContactSupport.module.css';

const ContactSupport: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <header className={styles.header}>
          <h1 className={styles.title}>Contact RealtyGenie Support</h1>
          <p className={styles.subtitle}>
            Our partners are here to help you with your agency payment and account needs.
          </p>
        </header>

        <div className={styles.partnersGrid}>
          <div className={styles.partnerCard}>
            <div className={styles.partnerInfo}>
              <h2 className={styles.partnerName}>Mariette Schoeman</h2>
              <p className={styles.partnerTitle}>Partner & Account Manager</p>
            </div>
            
            <div className={styles.contactDetails}>
              <div className={styles.contactItem}>
                <span className={styles.contactIcon}>📧</span>
                <a 
                  href="mailto:mariette@realtygenie.com" 
                  className={styles.contactLink}
                >
                  mariette@realtygenie.com
                </a>
              </div>
              
              <div className={styles.contactItem}>
                <span className={styles.contactIcon}>📞</span>
                <a 
                  href="tel:+27123456789" 
                  className={styles.contactLink}
                >
                  +27 12 345 6789
                </a>
              </div>
            </div>
            
            <p className={styles.partnerDescription}>
              Specializes in agency onboarding, payment processing, and account management.
            </p>
          </div>

          <div className={styles.partnerCard}>
            <div className={styles.partnerInfo}>
              <h2 className={styles.partnerName}>Thys Greef</h2>
              <p className={styles.partnerTitle}>Partner & Technical Support</p>
            </div>
            
            <div className={styles.contactDetails}>
              <div className={styles.contactItem}>
                <span className={styles.contactIcon}>📧</span>
                <a 
                  href="mailto:thys@realtygenie.com" 
                  className={styles.contactLink}
                >
                  thys@realtygenie.com
                </a>
              </div>
              
              <div className={styles.contactItem}>
                <span className={styles.contactIcon}>📞</span>
                <a 
                  href="tel:+27987654321" 
                  className={styles.contactLink}
                >
                  +27 98 765 4321
                </a>
              </div>
            </div>
            
            <p className={styles.partnerDescription}>
              Handles technical support, platform training, and integration assistance.
            </p>
          </div>
        </div>

        <div className={styles.additionalInfo}>
          <h3 className={styles.infoTitle}>General Support Information</h3>
          <ul className={styles.infoList}>
            <li>Support hours: Monday to Friday, 8:00 AM - 6:00 PM SAST</li>
            <li>Average response time: Within 4 business hours</li>
            <li>For urgent matters, please call directly</li>
            <li>We support multiple payment methods including EFT, credit card, and debit orders</li>
          </ul>
        </div>

        <div className={styles.actions}>
          <Link to="/payment-retry" className={styles.paymentButton}>
            Make Payment Instead
          </Link>
          <Link to="/" className={styles.backButton}>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;
